<div class="shipping-order-refund-modal">
  <p *ngIf="totalPoints">
    <strong>Glampoints a estornar</strong>: {{ totalPoints | number: '1.0-2' }}
  </p>
  <p *ngIf="shippingOrder?.shippingTotal || shippingOrder?.orderTotal">
    <strong>Frete a estornar</strong>:
    {{
      shippingOrder.shippingTotal || shippingOrder?.orderTotal | currency: 'BRL'
    }}
  </p>
  <p *ngIf="payment">
    <strong>Pagamento</strong>:
    <a [href]="gatewayLink" class="data-link" target="_blank">
      {{ payment.tid }}
    </a>
  </p>
  <p>
    <strong>Items a estornar</strong>:
    {{ itemsToRefund?.length | number: '1.0-0' }}
  </p>
  <app-table
    [cols]="cols"
    [lazy]="false"
    [elements]="itemsToRefund"
    [addButton]="false"
    modelName="itens"
    [showHeader]="false"
    [paginator]="false"
    *ngIf="itemsToRefund?.length"
  />
  <small
    class="error"
    *ngIf="
      gatewayPayment?.status === 'paid' &&
      (shippingOrder?.shippingTotal || shippingOrder?.orderTotal)
    "
  >
    * O estorno no gateway será feito automaticamente.
  </small>
  <span class="shipping-order-refund-modal__buttons">
    <p-button
      styleClass="p-button-danger"
      label="Confirmar Estorno"
      (click)="confirmRefund()"
    />
  </span>
</div>
<p-confirmDialog />
